<template>
  <b-card
    text-variant="center"
    class="card card-congratulations"
  >
    <!-- images -->
    <b-img
      :src="require('@/assets/images/elements/decore-left.png')"
      class="congratulations-img-left"
    />
    <b-img
      :src="require('@/assets/images/elements/decore-right.png')"
      class="congratulations-img-right"
    />
    <!--/ images -->

    <b-avatar
      variant="primary"
      size="70"
      class="shadow mb-2"
    >
      <feather-icon
        size="28"
        icon="AwardIcon"
      />
    </b-avatar>
    <h1 class="mb-1 mt-50 text-white">
      {{i18nT(`Congratulations`)}} {{ Label }},
    </h1>
    <b-card-text class="m-auto w-75">
      {{Signature}}
    </b-card-text>
  </b-card>
</template>

<script>
import {
  BCard, BImg, BAvatar, BCardText,
} from 'bootstrap-vue'
import useAuth from '@/auth/useAuth'

export default {
  components: {
    BCard,
    BAvatar,
    BImg,
    BCardText,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    const {FirstName, LastName, Label, Signature} = useAuth.getProfile()
    console.log(useAuth.getProfile())
    const fullName = FirstName + ' ' + LastName

    return {
      fullName,
      Label, Signature,
    }
  }
}
</script>
